/*
  Login page for FullStack.cash
*/

import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import { Container, Row, Col } from 'react-bootstrap'
import { isLoggedIn } from '../services/auth'
import LoginForm from '../components/auth/LoginForm'

function Login () {
  const navigate = useNavigate()

  useEffect(() => {
    // If user is already logged in, forward them to the private area.
    if (isLoggedIn()) {
      navigate('/profile')
    }
  }, [navigate])

  return (
    <>
      <Helmet>
        <title>API Keys for api.fullstack.cash - FullStack.cash</title>
      </Helmet>

      <Container className='py-5'>
        <Row>
          <Col md={{ span: 6, offset: 3 }}>
            <div className='text-center mb-4'>
              <h2>Get Your API Key</h2>
              <p>
                This site distributes API keys for the{' '}
                <a href='https://api.fullstack.cash' target='_blank' rel='noreferrer'>
                  api.fullstack.cash
                </a>{' '}
                REST API. Enter your email and password below to create an
                account or login.
              </p>
            </div>
            <LoginForm />
            <div className='text-center mt-4'>
              <p>
                If you need help or have questions, join our{' '}
                <a href='https://t.me/bch_js_toolkit' target='_blank' rel='noreferrer'>
                  Telegram channel
                </a>
                .
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Login
